import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  CircularProgress,
} from "@mui/material";
import { Step } from "utils/types/Info.types";


interface StepDialogProps {
  open: boolean;
  isSaving: boolean;
  onClose: () => void;
  onSave: (step: Omit<Step, 'id'> & { id?: string }) => void;
  initialData?: Step | null;
}

const emptyStep: Omit<Step, 'id'> = {
  step: "",
  description: "",
};

export const StepDialog: React.FC<StepDialogProps> = ({
  open,
  isSaving,
  onClose,
  onSave,
  initialData,
}) => {
  const [step, setStep] = useState(initialData || emptyStep);

  useEffect(() => {
    // Reset form when dialog opens or initialData changes
    if (open) {
      setStep(initialData || emptyStep);
    }
  }, [initialData, open]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setStep((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave(step);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {initialData?.id ? "Modifier l'Étape" : "Ajouter une Étape"}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            autoFocus
            label="Titre de l'étape"
            name="step"
            value={step.step}
            onChange={handleChange}
            fullWidth
            margin="none"
          />
          <TextField
            label="Description"
            name="description"
            value={step.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={4}
            margin="none"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={isSaving}>Annuler</Button>
        <Button 
          onClick={handleSave} 
          color="primary" 
          variant="contained" 
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isSaving ? "Sauvegarde..." : "Sauvegarder"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};